var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1737_46404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5.33397V18.9858C3.9998 20.3366 4.48247 21.6368 5.35008 22.6229C6.21769 23.6089 7.4053 24.2069 8.672 24.2955L9 24.3061H17.828C17.6212 24.9284 17.2383 25.4672 16.7318 25.8483C16.2253 26.2294 15.6203 26.4341 15 26.4342H8C6.4087 26.4342 4.88258 25.7616 3.75736 24.5643C2.63214 23.367 2 21.7431 2 20.0499V8.34525C1.99968 7.68484 2.19186 7.04058 2.55006 6.50126C2.90826 5.96194 3.41484 5.5541 4 5.33397ZM19 0.896851C19.7956 0.896851 20.5587 1.23317 21.1213 1.83182C21.6839 2.43046 22 3.24241 22 4.08902V18.9858C22 19.8324 21.6839 20.6444 21.1213 21.243C20.5587 21.8417 19.7956 22.178 19 22.178H9C8.20435 22.178 7.44129 21.8417 6.87868 21.243C6.31607 20.6444 6 19.8324 6 18.9858V4.08902C6 3.24241 6.31607 2.43046 6.87868 1.83182C7.44129 1.23317 8.20435 0.896851 9 0.896851H19ZM19 3.02496H9C8.73478 3.02496 8.48043 3.13707 8.29289 3.33662C8.10536 3.53617 8 3.80682 8 4.08902V18.9858C8 19.268 8.10536 19.5387 8.29289 19.7382C8.48043 19.9378 8.73478 20.0499 9 20.0499H19C19.2652 20.0499 19.5196 19.9378 19.7071 19.7382C19.8946 19.5387 20 19.268 20 18.9858V4.08902C20 3.80682 19.8946 3.53617 19.7071 3.33662C19.5196 3.13707 19.2652 3.02496 19 3.02496Z",
    fill: "#1E8B7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1737_46404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25.5374,
    fill: "white",
    transform: "translate(0 0.896851)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.4fa29948.svg";
export { ForwardRef as ReactComponent };